<template>
  <div class="page-table scrollable only-y mainDiv mb-30">
    <div class="card-base baslikBg animated fadeInUp">İzin Listesi
      <div class="tanimlamaButon">
        <el-tooltip :content='$t("src.views.apps.genel.yeniKaydet")' :open-delay="500" placement="top">
          <el-button v-on:click="goRoute('İzin Tanımla')" size="mini" type="text"
                     icon="el-icon-plus"></el-button>
        </el-tooltip>
        <el-tooltip :content='$t("src.views.apps.genel.refresh")' :open-delay="500" placement="top">
          <el-button v-on:click="refreshPage()" style="margin-left: 15px !important" type="text"
                     icon="el-icon-refresh"></el-button>
        </el-tooltip>
      </div>
    </div>
    <div class="page-header card-base card-shadow--medium animated fadeInUp" v-loading="loading"
         :element-loading-text='loading ? "İzin Listesi Getiriliyor Lütfen Bekleyiniz" : "İzin Durum Güncelleniyor. Lütfen Bekleyiniz."'
         element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)">
      <el-row class="mt-0 mb-10">
        <el-col :lg="12" :md="12" :sm="24" :xs="24">
          <div>
            <el-radio-group size="small" v-on:change="handleChange($event)" v-model="durum" fill="#E5F5F9"
                            text-color="gray" :disabled="searchLoading">
              <el-radio-button label="1">
                <i class="mdi mdi-account mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                <transition name="slide-fade">
                  <label v-if="durum == '1'">Aktif İzinler</label>
                </transition>
              </el-radio-button>
              <el-radio-button label="0">
                <i class="mdi mdi-account mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                <transition name="slide-fade">
                  <label v-if="durum == '0'">Pasif İzinler</label>
                </transition>
              </el-radio-button>
            </el-radio-group>
          </div>
        </el-col>
        <el-col :lg="12" :md="12" :sm="24" :xs="24">
          <el-col :lg="24" :md="24" :sm="24" :xs="24">
            <ul class="islemler">
              <li>
                <i class="mdi mdi-download mdi-18px" style="color: #4CCD99;"></i>
                <span>Belgeyi İndir</span>
              </li>
              <li>
                <i class="mdi mdi-printer mdi-18px" style="color: #86A7FC"></i>
                <span>Yazdır</span>
              </li>
              <li>
                <i class="mdi mdi-pen mdi-18px" style="color: #f7ba2a"></i>
                <span>Güncelle</span>
              </li>
              <li v-if="durum == '1'">
                <i class="mdi mdi-trash-can mdi-18px" style="color: #ec205f"></i>
                <span>Pasif Yap</span>
              </li>
              <li v-else>
                <i class="mdi mdi-play mdi-18px" style="color: #048484"></i>
                <span>Aktif Yap</span>
              </li>
            </ul>
          </el-col>
        </el-col>
      </el-row>
      <div class="my-custom-table">
        <el-table v-loading="searchLoading" border stripe :data="izinList"
                  style="width: 100%" :element-loading-text='"İzin Aranıyor. Lütfen Bekleyiniz."'
                  element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)">
          <el-table-column>
            <template slot="header" slot-scope="props">
              <el-input clearable v-on:clear="runSearch" placeholder='Personel Ara' v-model="search.personelAdi"
                        v-debounce:500ms="runSearch" size="mini"/>
            </template>
            <el-table-column prop="adSoyad" label="Personel Adı" min-width="250"/>
          </el-table-column>
          <el-table-column>
            <template slot="header" slot-scope="props">
              <el-select clearable @change="runSearch" v-model="search.izinTuru" placeholder="İzin Türüne Göre Ara"
                         size="mini">
                <el-option v-for="item in izinTuruOptions" :key="item.value" :label="item.label"
                           :value="item.value"/>
              </el-select>
            </template>
            <el-table-column prop="turID" label="İzin Türü" min-width="250">
              <template slot-scope="scope">
                <el-tag :style="{backgroundColor: getTurAdi(scope.row.turID).color,color:'white',border:'none'}"
                        class="izin-tur-tag">
                  {{ getTurAdi(scope.row.turID).label }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column>
            <el-table-column prop="aciklama" label='Açıklama' min-width="200"/>
          </el-table-column>
          <el-table-column>
            <el-table-column prop="baslangicTarihi" label='Başlangıç Tarihi' min-width="200"/>
          </el-table-column>
          <el-table-column>
            <el-table-column prop="bitisTarihi" label='Bitiş Tarihi' min-width="200"/>
          </el-table-column>
          <el-table-column>
            <el-table-column prop="izinGunu" label='İzin Günü' min-width="100" align="center"/>
          </el-table-column>
          <el-table-column>
            <el-table-column :label='$t("src.views.apps.genel.islem")' width="200" align="center">
              <template slot-scope="scope">
                <el-tooltip content='İndir' :open-delay="500" placement="bottom">
                  <el-button @click="download(scope.row.belge)" class="buttonDel"
                             type="text"
                             icon="mdi mdi-download mdi-24px"
                             style="color:#4CCD99!important;margin-right: 10px!important;"/>
                </el-tooltip>
                <el-tooltip content='Yazdır' :open-delay="500" placement="bottom">
                  <el-button @click="showDetay(scope.row)" class="buttonDel"
                             type="text"
                             icon="mdi mdi-printer mdi-24px"
                             style="color:#86A7FC!important;margin-right: 10px!important;"/>
                </el-tooltip>
                <el-tooltip content='Güncelle' :open-delay="500" placement="bottom">
                  <el-button @click="goUpdate(scope.row.izinID)" class="buttonDel"
                             type="text"
                             icon="mdi mdi-pen mdi-24px"
                             style="color:#f7ba2a!important;margin-right: 10px!important;"/>
                </el-tooltip>
                <el-tooltip content='Pasif Yap' :open-delay="500"
                            v-if="durum == '1'" placement="bottom">
                  <el-button @click="changeIzinDurum(scope.row, '0')" class="buttonDel"
                             type="text"
                             icon="mdi mdi-trash-can mdi-24px"/>
                </el-tooltip>
                <el-tooltip content='Aktif Yap' :open-delay="500"
                            v-if="durum == '0'" placement="bottom">
                  <el-button @click="changeIzinDurum(scope.row, '1')" type="text"
                             class="islem-button-play islem-button ml-15"
                             icon="mdi mdi-play mdi-24px"/>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination background layout="sizes,prev, pager, next, jumper, total" :total="total"
                     @size-change="handleSizeChange" @current-change="pageChange" :page-sizes="[20, 50, 100]"
                     :current-page.sync="page" :next-click.sync="page" :prev-click.sync="page" @next-click="pageChange"
                     @prev-click="pageChange">
      </el-pagination>
    </div>
    <el-dialog title="" :visible.sync="openIzinModal" width="60%" class="izin-print-dialog">
      <el-row id="izin-print" class="mt-20">
        <el-col :xl="24" :lg="24" :md="24" :sm="24" class="text-center">
          <img src="@/assets/images/demirag-login.png" alt="" width="200" class="izin-logo">
          <h2>Demirağ Organize Sanayi Bölgesi</h2>
          <el-divider class="izin-divider"/>
        </el-col>
        <el-col :xl="24" :lg="24" :md="24" :sm="24" class="text-center izin-icerik">
          <el-row>
            <el-col :span="24">
              <h3>MAZERET İZİN TALEP ve ONAY FORMU</h3>
            </el-col>
            <el-col :span="24" style="text-align: end">
              <h3 style="font-weight: 200">{{ currentDate }}</h3>
            </el-col>
            <el-col :span="24">
              <ul>
                <li>
                  <span>Adı-Soyadı</span>
                  <p>: {{ izinData.personelAdi }}</p>
                </li>
                <li>
                  <span>TC Kimlik Numarası</span>
                  <p>: </p>
                </li>
                <li>
                  <span>İşe Giriş Tarihi</span>
                  <p>: </p>
                </li>
                <li>
                  <span>Çalıştığı Bölüm</span>
                  <p>: </p>
                </li>
                <li>
                  <span>İkametgah Adresi</span>
                  <p>: </p>
                </li>
                <li>
                  <span>Telefon Numaraları</span>
                  <p>: </p>
                </li>
                <li>
                  <span>İznini Geçireceği Adres</span>
                  <p>: </p>
                </li>
                <li>
                  <span>İstenen Ücretsiz Yol İzni</span>
                  <p>: </p>
                </li>
              </ul>
              <p>İş kanununa göre mazeretin uygun görülmesi halinde <strong>{{ izinData.baslangicTarihi }}</strong>
                tarihinden itibaren <strong>{{ izinData.izinGunu }}</strong> gün mazeret kullanmak istiyorum.</p>
              <p>Gereğinin yapılmasını arz ederim.</p>
              <el-row>
                <el-col :span="24">
                  <p style="color: #c7c4c4;float: right;margin: 0;" class="personel-ad-soyad-imza">Personelin Adı
                    Soyadı</p>
                </el-col>
                <el-col :span="24">
                  <p style="color: #c7c4c4;float: right;margin: 0;" class="personel-ad-soyad-imza">İmza</p>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xl="24" :lg="24" :md="24" :sm="24" class="text-center insan-kaynaklari">
          <el-row class="mt-30">
            <el-col :span="24">
              <h3>** İNSAN KAYNAKLARI DEPARTMANI TARAFINDAN DOLDURILACAKTIR **</h3>
              <h3>MAZERET İZİN HESABI ve ONAYI</h3>
            </el-col>
            <el-col :span="24">
              <ul>
                <li>
                  <span>İzne Çıkış Tarihi</span>
                  <p>: {{ izinData.baslangicTarihi }}</p>
                </li>
                <li>
                  <span>İzin Bitiş Tarihi</span>
                  <p>: {{ izinData.bitisTarihi }}</p>
                </li>
                <li>
                  <span>Mazeret İzin Süresi</span>
                  <p>: {{ izinData.izinGunu }} Gün</p>
                </li>
              </ul>
              <p>Adı geçen personelin {{ izinData.baslangicTarihi }} - {{ izinData.bitisTarihi }} tarihleri arasında
                mazeret iznini kullanması uygun görülmüştür.</p>
            </el-col>
            <el-col :span="24" style="text-align: end">
              <h3 style="font-weight: 200">{{ currentDate }}</h3>
            </el-col>
            <el-col :span="12">
              <span style="letter-spacing: 7px">..................................</span>
              <p>İnsan Kaynakları Sorumlusu</p>
            </el-col>
            <el-col :span="12">
              <span style="letter-spacing: 7px;">..................................</span>
              <p>Şantiye Şefi / Proje Müdürü / Şirket Müdürü</p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          :filename="`${izinData.personelAdi} - ${izinData.izinTuru}`"
          :pdf-quality="5"
          :manual-pagination="true"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="750px"
          ref="izinhtml2Pdf"
      >
        <section slot="pdf-content">
          <el-row class="mt-20">
            <el-col :xl="24" :lg="24" :md="24" :sm="24" class="text-center">
              <img src="@/assets/images/demirag-login.png" alt="" width="200" class="izin-logo">
              <h2>Demirağ Organize Sanayi Bölgesi</h2>
              <el-divider class="izin-divider"/>
            </el-col>
            <el-col :xl="24" :lg="24" :md="24" :sm="24" class="text-center izin-icerik">
              <el-row>
                <el-col :span="24">
                  <h3 style="margin: 0;">MAZERET İZİN TALEP ve ONAY FORMU</h3>
                </el-col>
                <el-col :span="24" style="text-align: end">
                  <h3 style="margin: 0;font-weight: 200">{{ currentDate }}</h3>
                </el-col>
                <el-col :span="24">
                  <ul style="list-style-type: none;text-align: left;">
                    <li>
                      <span style="width: 200px;display: inline-block;">Adı-Soyadı</span>
                      <p style="display: inline-block;margin: 10px;height: 6px;">: {{ izinData.personelAdi }}</p>
                    </li>
                    <li>
                      <span style="width: 200px;display: inline-block;">TC Kimlik Numarası</span>
                      <p style="display: inline-block;margin: 10px;height: 6px;">: </p>
                    </li>
                    <li>
                      <span style="width: 200px;display: inline-block;">İşe Giriş Tarihi</span>
                      <p style="display: inline-block;margin: 10px;height: 6px;">: </p>
                    </li>
                    <li>
                      <span style="width: 200px;display: inline-block;">Çalıştığı Bölüm</span>
                      <p style="display: inline-block;margin: 10px;height: 6px;">: </p>
                    </li>
                    <li>
                      <span style="width: 200px;display: inline-block;">İkametgah Adresi</span>
                      <p style="display: inline-block;margin: 10px;height: 6px;">: </p>
                    </li>
                    <li>
                      <span style="width: 200px;display: inline-block;">Telefon Numaraları</span>
                      <p style="display: inline-block;margin: 10px;height: 6px;">: </p>
                    </li>
                    <li>
                      <span style="width: 200px;display: inline-block;">İznini Geçireceği Adres</span>
                      <p style="display: inline-block;margin: 10px;height: 6px;">: </p>
                    </li>
                    <li>
                      <span style="width: 200px;display: inline-block;">İstenen Ücretsiz Yol İzni</span>
                      <p style="display: inline-block;margin: 10px;height: 6px;">: </p>
                    </li>
                  </ul>
                  <p>İş kanununa göre mazeretin uygun görülmesi halinde <strong>{{ izinData.baslangicTarihi }}</strong>
                    tarihinden itibaren <strong>{{ izinData.izinGunu }}</strong> gün mazeret kullanmak istiyorum.</p>
                  <p>Gereğinin yapılmasını arz ederim.</p>
                  <el-row>
                    <el-col :span="24">
                      <p style=" color: #c7c4c4;float: right;margin: 0;" class="personel-ad-soyad-imza">Personelin Adı
                        Soyadı</p>
                    </el-col>
                    <el-col :span="24">
                      <p style=" color: #c7c4c4;float: right;margin: 0;" class="personel-ad-soyad-imza">İmza</p>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xl="24" :lg="24" :md="24" :sm="24" class="text-center insan-kaynaklari">
              <el-row>
                <el-col :span="24">
                  <h3 style="margin: 0;">** İNSAN KAYNAKLARI DEPARTMANI TARAFINDAN DOLDURILACAKTIR **</h3>
                  <h3 style="margin: 0;">MAZERET İZİN HESABI ve ONAYI</h3>
                </el-col>
                <el-col :span="24">
                  <ul style="list-style-type: none;text-align: left;">
                    <li>
                      <span style="width: 200px;display: inline-block;">İzne Çıkış Tarihi</span>
                      <p style="display: inline-block;margin: 10px;height: 6px;">: {{ izinData.baslangicTarihi }}</p>
                    </li>
                    <li>
                      <span style="width: 200px;display: inline-block;">İzin Bitiş Tarihi</span>
                      <p style="display: inline-block;margin: 10px;height: 6px;">: {{ izinData.bitisTarihi }}</p>
                    </li>
                    <li>
                      <span style="width: 200px;display: inline-block;">Mazeret İzin Süresi</span>
                      <p style="display: inline-block;margin: 10px;height: 6px;">: {{ izinData.izinGunu }} Gün</p>
                    </li>
                  </ul>
                  <p>Adı geçen personelin {{ izinData.baslangicTarihi }} - {{ izinData.bitisTarihi }} tarihleri arasında
                    mazeret iznini kullanması uygun görülmüştür.</p>
                </el-col>
                <el-col :span="24" style="text-align: end">
                  <h3 style="margin: 10px;font-weight: 200">{{ currentDate }}</h3>
                </el-col>
                <el-col :span="12" class="mt-30">
                  <span style="letter-spacing: 7px">..................................</span>
                  <p>İnsan Kaynakları Sorumlusu</p>
                </el-col>
                <el-col :span="12" class="mt-30">
                  <span style="letter-spacing: 7px;">..................................</span>
                  <p>Şantiye Şefi / Proje Müdürü / Şirket Müdürü</p>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </section>
      </vue-html2pdf>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openIzinModal = false">Kapat</el-button>
        <el-button type="primary" @click="generateReport()">Yazdır</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EventBus from '@/components/event-bus'
import notification from '../../../notification'
import functions from '../../../functions'
import talimatService from "@/WSProvider/TalimatService";
import izinService from "@/WSProvider/izinService";
import moment from "moment";
import VueHtml2pdf from 'vue-html2pdf'
import personelService from "@/WSProvider/PersonelService";


export default {
  name: "IzinListesi",
  components: {VueHtml2pdf},
  data() {
    return {
      loading: false,
      searchLoading: false,
      durum: '1',
      page: 0,
      postPage: 0,
      total: 0,
      sizes: 20,
      openIzinModal: false,
      currentDate: null,
      izinData: [],
      izinTuruOptions: [
        {label: 'Yıllık İzin', value: '1'},
        {label: 'Rapor', value: '2'},
        {label: 'Mazeret İzni', value: '3'},
        {label: 'Ücretsiz İzin', value: '4'},
        {label: 'Alacak İzin', value: '5'},
        {label: 'İş Arama İzni', value: '6'},
        {label: 'Pandemi İzni', value: '7'},
      ],
      izinList: [
        {
          id: 1,
          personelAdi: 'Turan Ali',
          izinTuru: 'Ücretsiz İzin',
          aciklama: 'Doğum İzni',
          belge: 'belge',
          baslangicTarihi: '2024-03-01',
          bitisTarihi: '2024-03-30',
          izinGunu: '12',
        }
      ],
      search: {
        personelAdi: '',
        izinTuru: '',
      },
    }
  },
  created() {
    this.checkDevice();
    if (localStorage.getItem("userDataDemirag")) {
      this.yetkiTuru = this.$store.getters.getYetkiTuru;
      this.yetkiListesi = this.$store.getters.getYetkiListesi;
      this.yoneticiID = this.$store.getters.getYoneticiID;
      //console.log(this.yetkiListesi)
    }
  },
  mounted() {
    this.currentDate = moment().format('DD/MM/YYYY');
    this.getIzinListesi();
    window.addEventListener('resize', this.checkDevice);
    EventBus.$on("izinListesi", () => {
      this.refreshPage()
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    goUpdate(izinID) {
      this.$store.commit('setGuncellenecekIzinID', izinID)
      functions.routeSayfa("İzin Güncelle", this)
    },
    download(belge) {
      window.open(izinService.belge + belge, "_blank");
    },
    getTurAdi(tur) {
      if (tur == 1) {
        return {
          label: 'Yıllık İzin',
          color: '#4CCD99',
        }
      }
      if (tur == 2) {
        return {
          label: 'Rapor',
          color: '#FFAF45',
        }
      }
      if (tur == 3) {
        return {
          label: 'Mazeret İzni',
          color: '#2C7865',
        }
      }
      if (tur == 4) {
        return {
          label: 'Ücretsiz İzin',
          color: '#50C4ED',
        }
      }
      if (tur == 5) {
        return {
          label: 'Alacak İzin',
          color: '#EABE6C',
        }
      }
      if (tur == 6) {
        return {
          label: 'İş Arama İzni',
          color: '#824D74',
        }
      }
      if (tur == 7) {
        return {
          label: 'Pandemi İzni',
          color: '#FFBE98',
        }
      }
      return {
        label: 'Belirsiz',
        color: '#E72929'
      }
    },
    generateReport() {
      this.$refs.izinhtml2Pdf.generatePdf()
    },
    showDetay(data) {
      const baslangicTarihi = moment(data.baslangicTarihi).format('DD/MM/YYYY')
      const bitisTarihi = moment(data.bitisTarihi).format('DD/MM/YYYY')
      this.izinData = {...data, baslangicTarihi, bitisTarihi}
      this.openIzinModal = true
    },
    checkDevice() {
      this.isDesktop = window.innerWidth >= 768;
    },
    runSearch() {
      const self = this
      this.postPage = 0;
      this.page = 1
      if (this.search.personelAdi.length > 0 || this.search.izinTuru.length > 0) {
        this.searchLoading = true;
        izinService.izinSearch(this.durum, this.postPage, this.sizes, this.search).then(response => {
          if (response.status == 200) {
            localStorage.setItem("userDataDemirag", response.token);
            this.izinList = response.data;
            this.total = parseInt(response.toplamKayit)
          } else {
            this.izinList = [];
            this.total = 0
          }
        }).catch(err => {
          this.izinList = [];
          this.total = 0
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else if (error.status == 404) this.izinList = []
          }
        }).finally(() => self.searchLoading = false)
      } else this.getIzinListesi();
    },
    refreshPage() {
      this.page = 1;
      this.postPage = 0;
      this.loading = false;
      this.getIzinListesi();
    },
    vazgec(formName) {
      this.$refs[formName].resetFields();
      this.editDialog = false;
      this.loading = false;
    },
    changeIzinDurum(selection, durum) {
      this.$confirm("İzin durumunu güncellemek istediğinizden emin misiniz?", this.$t("src.views.apps.genel.uyari"), {
        confirmButtonText: this.$t("src.views.apps.genel.yes"),
        cancelButtonText: this.$t("src.views.apps.genel.no"),
        type: 'warning'
      }).then(() => {
        izinService.izinDurumDegis(selection.izinID, durum).then(response => {
          if (response.status == 200) {
            localStorage.setItem("userDataDemirag", response.token);
            notification.Status("success", this, response.msg);
            this.getIzinListesi();
          } else notification.Status("success", this, response.msg || response.errMsg);
        }).catch(err => {
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else notification.Status("errorMsg", this, error.msg || error.errMsg)
          }
        })
      })
    },
    getIzinListesi() {
      const self = this
      this.loading = true;
      izinService.izinListesi(this.durum, this.postPage, this.sizes).then((response) => {
        localStorage.setItem("userDataDemirag", response.token)
        if (response.status == 200) {
          this.izinList = response.data;
          this.total = parseInt(response.toplamKayit);
        } else {
          this.izinList = [];
          this.total = 0;
          notification.Status("errorMsg", this, response.msg || response.errMsg)
        }
      }).catch(err => {
        if (err.responseJSON) {
          let error = err.responseJSON
          if (error.status == 401) {
            notification.Status(150, this);
          } else if (error.status == 404) {
            this.izinList = [];
          } else notification.Status("errorMsg", this, error.msg || error.errMsg)
        }
      }).finally(() => self.loading = false)
    },
    goRoute(name, scope) {
      if (scope) {
        this.$store.commit('changeMusteriUpdateData', scope);
      }
      functions.routeSayfa(name, this);
    },
    indexMethod(index) {
      return ((this.page - 1) * this.sizes) + index + 1;
    },
    handleSizeChange(val) {
      this.sizes = val;
      this.getIzinListesi();
    },
    handleChange(event) {
      this.durum = event;
      this.page = 1;
      this.postPage = 0;
      this.getIzinListesi();
      document.querySelector('.scrollable').scrollTo({top: 0, behavior: 'smooth'});
      this.firmaAdiAra = ""
      this.unvanAra = ""
      this.adresAra = ""
      this.telefonAra = ""
      this.epostaAra = ""
    },
    pageChange(val) {
      this.postPage = (val - 1) * this.sizes;
      this.getIzinListesi();
    },
  }
}
</script>

<style lang="scss">
.izin-tur-tag {
  height: 25px;
  color: white;
  border: none;
  place-content: center;
  place-items: center;
  display: inline-grid;
}

.izin-print-dialog {
  .el-dialog__header {
    display: none;
  }

  .insan-kaynaklari {
    ul {
      list-style-type: none;
      text-align: left;

      p {
        display: inline-block;
        margin: 10px;
        height: 6px;
      }

      span {
        width: 200px !important;
        display: inline-block;
      }
    }
  }

  .izin-icerik {
    .personel-ad-soyad-imza {
      color: #c7c4c4;
      float: right;
      margin: 0;
    }

    ul {
      list-style-type: none;
      text-align: left;

      p {
        display: inline-block;
        margin: 10px;
        height: 6px;
      }

      span {
        width: 200px !important;
        display: inline-block;
      }
    }

    h3 {
      margin: 0;
    }
  }

  .el-dialog__body {
    .izin-divider {
      margin-top: 50px !important;
    }

    h2 {
      margin-top: 30px;
    }

    .izin-logo {
      position: absolute;
      left: 0;
    }
  }
}

.el-table .info-row {
  background: rgba(125, 199, 225, 0.45);
}

.el-table .error-row {
  background: rgba(249, 0, 26, 0.08);
}

.el-table .success-row {
  background: rgba(3, 249, 0, 0.08);
}

.el-table .warning-row {
  background: rgba(245, 249, 0, 0.08);
}
</style>
<style lang="scss" scoped>
.upload-tooltip {
  width: 20% !important;
}

.upload-tooltip-modal {
  width: 6% !important;
}

.upload-btn {
  height: 40px !important;
  background-color: red;
  border: none;
}

.download-btn {
  height: 40px !important;
  background-color: #00A9FF;
  border: none;
}

.refresh {
  color: #fff;
  float: right;
  padding: 0 !important;
  transition: all 0.5s;

}

.refresh:hover {
  transform: rotate(360deg);
}

.el-pagination {
  margin-top: 20px;
  float: right;
}

.el-radio-button--mini .el-radio-button__inner label {
  position: relative;
  bottom: 5px;
}

.kaldirilmis {
  background: #ec205f;
  color: white;
  font-weight: bold;
  font-size: 16px;
  padding: 10px
}
</style>
<style lang="scss">
.slide-fade-enter-active {
  transition: all .3s ease;
}


@media (min-width: 768px) {
  .el-radio-button--mini .el-radio-button__inner {
    padding: 0 10px !important;
    font-size: 11px;
    border-radius: 0;
  }
}


.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to

  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}
</style>
<style>
/*
    .tablo{
        background-color: rgb(59, 123, 179); /*rgb(148, 197, 240);
    }*/

.tablo th.el-table__cell > .cell {
  background-color: aliceblue;
}


.islem-button {
  padding-top: 1px;
  padding-bottom: 1px;
  margin-top: 1px;
  margin-bottom: 1px;
  font-size: 0;
  line-height: 1;
  /* Butonun içeriği ile yükseklik arasındaki mesafeyi sıfırlar */
}

.buttonDel {
  padding-top: 1px;
  padding-bottom: 1px;
  margin-top: 1px;
  margin-bottom: 1px;
  font-size: 0;
  line-height: 1;
  /* Butonun içeriği ile yükseklik arasındaki mesafeyi sıfırlar */
}

.el-table .cell {
  line-height: 17px !important;
}

.el-table thead {
  line-height: 30px !important;
}
</style>